import { render, staticRenderFns } from "./MailLayout.vue?vue&type=template&id=07200aa2&scoped=true&"
import script from "./MailLayout.vue?vue&type=script&lang=ts&"
export * from "./MailLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MailLayout.vue?vue&type=style&index=0&id=07200aa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07200aa2",
  null
  
)

export default component.exports